import { createSelector } from "@reduxjs/toolkit";

import { selectFacetedResults } from "./select-faceted-results";

export const selectUnmatchedResults = createSelector(
	[selectFacetedResults],
	(facetedResults) => {
		return facetedResults?.UnmatchedResults;
	},
);
